import colors from '../../colors';

const DayScreenTheme = {
  appColors: {
    background: colors.linearGradient,
    titleText: colors.gray.light,
    regularText: colors.white.primary,
    contentBackground: colors.conentGradient,
    secondaryGray: colors.gray.dary,
    bottomBar: colors.bottomGradient,
    dayDateBackground: colors.blue.blueDark,
  },
};

export default DayScreenTheme;
